import { useDispatch, useSelector } from "react-redux";
import ExpandingFlexCard from "../expandingFlexCard/ExpandingFlexCard";
import styles from "./PageMainBodyOne.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getPost, deletePost } from "../../redux/features/post/postSlice";
import { addLike } from "../../redux/features/post/postSlice";
import { removeLike } from "../../redux/features/post/postSlice";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import { FaEdit, FaTrash } from "react-icons/fa";
import { AdminOnlyLink } from "../hiddenLink/AdminOnlyRoute";

import DOMPurify from "dompurify";
import AddComment from "../../pages/addComments/AddComment";
import StickyLike from "../stickyLike/StickyLike";
import Loader from "../loader/Loader";
import RelatedPosts from "../relatedPost/RelatedPosts";
import UpNextPost from "../upNextPosts/UpNextPosts";
import SharePost from "../sharePost/SharePost";

const MainBodyOne = () => {
  // const { id } = useParams();
  const { identifier } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [imageIndex, setImageIndex] = useState(0);
  const { post, isLoading } = useSelector((state) => state.post);
  const { isLoggedIn } = useSelector((state) => state.auth);

  const confirmDelete = (id) => {
    confirmAlert({
      title: "Delete Product",
      message: "Are you sure to delete this post?.",
      buttons: [
        {
          label: "Delete",
          onClick: () => delPost(id),
        },
        {
          label: "Cancel",
        },
      ],
    });
  };

  const delPost = async (id) => {
    await dispatch(deletePost(id));
  };

  useEffect(() => {
    dispatch(getPost(identifier));
  }, [dispatch, identifier]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [dispatch, identifier]);

  return (
    <>
      {isLoading && <Loader />}
      <section
        className={`${styles["blog-post"]} ${styles["section-header-offset"]}`}
      >
        <div className={`${styles["blog-post-container"]} ${styles.container}`}>
          <div className={styles["blog-post-data"]}>
            <h1 className={`${styles.title} ${styles["blog-post-title"]}`}>
              {post?.title}
            </h1>
            <div className={styles["article-data"]}>
              <p>By: {post?.author}, BeckyNews</p>
              <p>
                <span>Created</span> &nbsp;
                {/* {moment(post?.createdAt).format("DD-MMM-YYYY")} */}
                {moment(post?.createdAt).fromNow()}
              </p>
              {/* {post?.updatedAt > post?.createdAt && (
                <p>
                  <span>Updated</span> &nbsp;
                  {moment(post?.updatedAt).fromNow()}
                </p>
              )} */}
              <p>{post?.minuteRead}</p>
            </div>
            <SharePost post={post} />

            <img src={post?.image[imageIndex]} alt="" />

            {post?.image.length > 1 && (
              <ExpandingFlexCard
                img0={post?.image[0]}
                img1={post?.image[1]}
                img2={post?.image[2]}
                img3={post?.image[3]}
                img4={post?.image[4]}
              />
            )}
          </div>
          <AdminOnlyLink>
            <div className={styles.actions}>
              <span>
                <Link to={`/admin/edit-post/${post?._id}`}>
                  <FaEdit size={20} color={"green"} />
                </Link>
              </span>
              <span>
                <FaTrash
                  size={20}
                  color={"red"}
                  onClick={() => confirmDelete(post?._id)}
                />
              </span>
            </div>
          </AdminOnlyLink>

          <div className={styles.container}>
            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(post?.content),
              }}
            ></p>

            {/* <div className={`${styles.author} ${styles["d-grid"]}`}>
              <div className={styles["author-image-box"]}>
                <img
                  src="./assets/images/author.jpg"
                  alt=""
                  className={styles["article-image"]}
                />
              </div>
              <div className={styles["author-about"]}>
                <h3 className={styles["author-name"]}>{post?.author}</h3>
                <p>
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Eaque quis repellat rerum, possimus cumque dolor repellendus
                  eligendi atque explicabo exercitationem id.
                </p>
                <ul className="list social-media">
                  <li className="list-item">
                    <Link className="list-link">
                      <i className="ri-instagram-line"></i>
                    </Link>
                  </li>
                  <li className="list-item">
                    <Link className="list-link">
                      <i className="ri-facebook-circle-line"></i>
                    </Link>
                  </li>
                  <li className="list-item">
                    <Link className="list-link">
                      <i className="ri-twitter-line"></i>
                    </Link>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>

          {/* Comments List */}
          <div className="--m ">
            {post?.comments?.length === 0 ? (
              <p>There is no comment for this post yet.</p>
            ) : (
              <>
                {post?.comments?.map((comment, index) => {
                  const { text, created, postedBy } = comment;
                  return (
                    <div className="card ">
                      <div className="comment" key={post?.comments?._id}>
                        <span>
                          <b>By: {postedBy?.name}</b>
                        </span>
                        <p style={{ color: "#ff9f31" }}>{text}</p>
                        <span>
                          <b>{moment(created).fromNow()}</b>
                        </span>
                        <br />
                      </div>
                      <hr />
                    </div>
                  );
                })}
              </>
            )}
          </div>
          {isLoggedIn && <AddComment />}
        </div>
        <RelatedPosts />
        <UpNextPost />
      </section>
      <StickyLike
        isLoggedIn={isLoggedIn}
        navigate={navigate}
        dispatch={dispatch}
        addLike={addLike}
        removeLike={removeLike}
        id={identifier}
      />
    </>
  );
};
export default MainBodyOne;
